import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip } from "antd";
import { getIconByType } from "../../../../libs/documentsUtils";

import { useSelector } from "react-redux";
import FooterList from "./footerList";
import WidgetListview from "../../../widget/listView";
import { FormattedMessage, useIntl } from "react-intl";
import { FEATURE_TOGGLE_DOCUMENTS_SEARCH_ACCURACY } from "../../../../config";

/**
 * Disegna la card di un widget solitamente la card su DBOX si divide in 3 sul 100% di spazio disponibile
 * usiamo il type per capire in quanto dividere lo spazio es. 1 su 4 colonne oppure 2 su 3 colonne etc..
 * Il default lo etichetterei come box1_3 se voglio dividere per 3 e prendere 1 sola colonna box2_3 se voglio
 * che il box occupi 2 colonne su 3
 */
const ListBlock = props => {
  const { getDownload, handleClick, item } = props;
  const intl = useIntl();
  let infolistFilename = item.infoList
    ? item.infoList.find(el => {
      return el.label === "Nome file";
    })
    : null;
  let filename = infolistFilename
    ? infolistFilename.value
    : item.fileName
      ? item.fileName
      : "unnamed";

  const documentsTypes = useSelector(state =>
    state.documents && state.documents.classification
      ? state.documents.classification.typesDocuments
      : null);

  return (
    <div
      style={{ cursor: "pointer" }}
    >
      <WidgetListview
        actionsButtons={
          <FooterList
            documentId={item.documentId}
            filename={filename}
            getDownload={getDownload}
            handleClick={handleClick}
            isEinvoice={item.isInvoice}
            subtitle={item.subtitle}
            notesCount={item.notesCount}
          />
        }
        infoListContent={
          item.infoList &&
          item.infoList.map(el => (
            <div key={"result_" + el.label} className="detailListCard">
              {intl.formatMessage({id: "documents.toTranslate." + el.label, defaultMessage: el.label})} : <b>{el.value}</b>
            </div>
          ))
        }
        leftIcon={
          <FontAwesomeIcon
            icon={["far", getIconByType(item.title, documentsTypes)]}
            style={{ color: "#005075", fontSize: "24px" }}
          />
        }
        notificationsBadge={
          <div style={{ minWidth: "78px" }}>
            <div className="list-block-read-icon" >
              <div>
                <FontAwesomeIcon
                  icon={["fas", "check-circle"]}
                  style={{
                    color: item.read ? "#8bc34a" : "#86899d",
                    fontSize: "24px"
                  }}
                />
              </div>
            </div>
          </div>
        }
        onClick={e => handleClick(
          e, item.documentId, item.subtitle
        )}
        titleCatergory={
          <>
            {FEATURE_TOGGLE_DOCUMENTS_SEARCH_ACCURACY === "true" && (
              <p className="searchAccuracy">
                {" "}
                <FormattedMessage id="documents.detail.accuracy" />{" "}
                {Math.round(item.documentSearchScorePercentage)}%{" "}
              </p>
            )}
            <div className="absoluteEllipsisTitle">
              {item.subtitle ? item.subtitle : intl.formatMessage({id: "documents.toTranslate." + item.title, defaultMessage: item.title})}{" "}
              {item.visibleByStudioOnly ? (
                <Tooltip color={"rgb(0, 80, 117)"}
                  placement="top" title={intl.formatMessage({id: "documents.visibleStudioOnly", defaultMessage: "Visibile solo allo studio"})}>
                  <FontAwesomeIcon
                    icon={["far", "minus-hexagon"]}
                    className="list-block-visible-icon"
                  />
                </Tooltip>
              ) : null}
              {item.encrypted ? (
                <Tooltip color={"rgb(0, 80, 117)"}
                  placement="top" title={intl.formatMessage({id: "documents.crypted", defaultMessage: "Documento criptato"})}>
                  <FontAwesomeIcon
                    icon={["far", "key"]}
                    className="list-block-key-icon"
                  />
                </Tooltip>
              ) : null}
            </div>
          </>
        }
      />
    </div>
  );
};

export default ListBlock;
